module.exports = __webpack_public_path__ + "img/diva of the lake.910448c5.png";